import { createAction } from '@reduxjs/toolkit'

import { ApiKey } from 'types/GlobalApiKey'

// tryGetAllApiKeys
export const getAll = createAction('get_all_api_keys')
export const getAllSuccess = createAction<{ data: ApiKey[] }>(
  'get_all_api_keys_success'
)
export const getAllFailed = createAction('get_all_api_keys_failed')

// tryCreateApiKey
export const create = createAction('create_api_key')
export const createSuccess = createAction<{ data: ApiKey }>(
  'create_api_key_success'
)
export const createFailed = createAction('create_api_key_failed')

// tryDeleteApiKey
export const destroy = createAction('destroy_api_key')
export const destroySuccess = createAction<string>('destroy_api_key_success')
export const destroyFailed = createAction('destroy_api_key_failed')

// tryAssignExportTablesToApiKey
export const assignExportTablesToApiKey = createAction(
  'assign_export_tables_to_api_key'
)
export const assignExportTablesToApiKeySuccess = createAction<{
  id: string
  exportTableIds: string[]
  removedExportTableIds: string[]
}>('assign_export_tables_to_api_key_success')
export const assignExportTablesToApiKeyFailed = createAction(
  'assign_export_tables_to_api_key_failed'
)
